import { isEqual } from 'lodash';
import { takeLatest, put, select } from 'redux-saga/effects';

function* watch() {}

export default {
  watch,
};
